<svg class="new-loading" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96">
  <path class="draw" stroke="#64DDE3" stroke-linecap="round" stroke-width="3.5" d="M38.5 59S54 50.3 54 43.5c0-12.5-21-12.5-21 1 0 7 15.3 17 15.6 17 .4 0 15.4-10.2 15.4-17 0-13-21-13.5-21-1 0 7 15.5 15.5 15.5 15.5"/>
</svg>
